module.exports = __webpack_public_path__ + "img/kanban01.be8b53fe.png";